import React from "react";
import SectionHeading from "./sectionHeading";
import SolutionsList from "./solutionsList";

const SectionList = ({ content }) => {
  return (
    <div id="sectionList">
      <SectionHeading title={content.title} subtitle={content.subtitle} />
      <div className="list">
        <SolutionsList list={content.list} />
      </div>
    </div>
  );
};

export default SectionList;
